'use client'

import { useTranslation } from 'react-i18next'
import { LuFacebook, LuInstagram, LuLinkedin } from 'react-icons/lu'
import { Box, Flex, Text } from '@chakra-ui/react'
import Link from 'next/link'

import { Container } from 'styles/shared'

import { StyledLink } from './styles'

export const Footer = (): JSX.Element => {
  const { t } = useTranslation('common')

  return (
    <Box>
      <Box backgroundColor="black" paddingY="30px">
        <Container>
          <Flex direction={{ base: 'column', md: 'row' }} justifyContent="space-between" alignItems="center">
            <Flex color="white" direction={{ base: 'column', md: 'row' }}>
              <Link href="/faq" prefetch={false} legacyBehavior>
                <StyledLink>{t('faq')}</StyledLink>
              </Link>

              <Link href="/privacy-policy" prefetch={false} legacyBehavior>
                <StyledLink>{t('privacyPolicy')}</StyledLink>
              </Link>

              <Link href="/terms-of-use" prefetch={false} legacyBehavior>
                <StyledLink>{t('termsOfUse')}</StyledLink>
              </Link>

              <Link href="/contact" prefetch={false} legacyBehavior>
                <StyledLink>{t('contactUs')}</StyledLink>
              </Link>
            </Flex>

            <Flex marginTop={{ base: '22px', md: 0 }} marginBottom={{ base: '15px', md: 0 }}>
              <a href="https://www.facebook.com/leid.no" target="_blank" rel="noopener noreferrer">
                <Flex
                  alignItems="center"
                  justifyContent="center"
                  borderRadius="full"
                  backgroundColor="grey"
                  color="black"
                  width="24px"
                  height="24px"
                >
                  <LuFacebook size={18} fill="black" strokeWidth={0.5} />
                </Flex>
              </a>

              <Box marginX="42px">
                <a href="https://www.instagram.com/leid.no/" target="_blank" rel="noopener noreferrer">
                  <Flex
                    alignItems="center"
                    justifyContent="center"
                    borderRadius="full"
                    backgroundColor="grey"
                    color="black"
                    width="24px"
                    height="24px"
                  >
                    <LuInstagram size={17} strokeWidth={2} />
                  </Flex>
                </a>
              </Box>

              <a href="https://www.linkedin.com/company/leid-no/" target="_blank" rel="noopener noreferrer">
                <Flex
                  alignItems="center"
                  justifyContent="center"
                  borderRadius="full"
                  backgroundColor="grey"
                  color="black"
                  width="24px"
                  height="24px"
                >
                  <LuLinkedin size={16} fill="black" strokeWidth={0.5} />
                </Flex>
              </a>
            </Flex>
          </Flex>
        </Container>
      </Box>
      <Flex justifyContent="center" alignItems="center" backgroundColor="rgba(2, 17, 12, 0.9)">
        <Text paddingY="14px" textAlign="center" color="white">
          {t('allRightsReserved')}
        </Text>
      </Flex>
    </Box>
  )
}
